(function() {
  'use strict';

  angular
    .module('pub.sets.waitlist.service', [])
    .factory('SetsWaitlistService', SetsWaitlistService);

  /** @ngInject */
  function SetsWaitlistService($http, $q, API) {
    function list(id, start, limit, sort){
      var defered = $q.defer();

      $http.get(API.API_URL + 'publisher/sets/' + id + '/waitlists/users?start=' + start + '&limit=' + limit + '&sort=' + sort)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
      list: list
    };

  }

})();
